import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { APIURL, APIURLCOT } from "../../../Config";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import { DownloadTableExcel } from "react-export-table-to-excel";
import Pagination from "../../Pagination/Pagination";
import LoanDetails from "../../LoanDetails";

function FunnelCT() {
  const token = localStorage.getItem("token");

  const [activeTab, setActiveTab] = useState("home");
  const [list, setClist] = useState([]);
  const [option, setOption] = useState("ALL");
  const [funnel, SetFunnel] = useState([]);
  const [data, setData] = useState([]);
  const [allFunnelData, setDataAllFunnelData] = useState([]);
  const [allCPCFunnelData, setDataAllCPCFunnelData] = useState([]);

  const [isLoader, setIsLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [month, setMonth] = useState(0);
  const [months, setMonths] = useState([]);
  const [selectedMode, setSelectedMode] = useState("openmarket");
  const [selectedModeNes, setSelectedModeNes] = useState("all");

  const [selectDate, setSelectDate] = useState(false);
  const [dateValue1, setDateValue1] = useState("");
  const [dateValue2, setDateValue2] = useState("");
  const [lid, setLid] = useState("");
  const [row, setRow] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const tableRef = useRef(null);
  const tableFunnel = useRef(null);
  const [showPrePage, setShowPrePage] = useState(100);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPrePage,
  });
  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const getMonthName = (date) =>
    date.toLocaleString("default", { month: "long" });

  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();

    const monthsArray = [];
    for (let i = 0; i < 3; i++) {
      const monthDate = new Date(currentYear, now.getMonth() - i, 1);
      const monthName = getMonthName(monthDate);
      monthsArray.push({
        name: `${monthName} ${currentYear}`,
        value: i.toString(),
      });
    }

    setMonths(monthsArray);
    setMonth("0");
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    getRejectionReasonscsa();
  }, [option, dateValue1]);

  useEffect(() => {
    getClist();
  }, []);

  useEffect(() => {
    if (activeTab === "home") {
      setSelectedMode("openmarket");
      setSelectedModeNes("all");
      getAllfunnelreport();

      const todayDate = new Date();
      setDateValue2(moment(todayDate).format("YYYY-MM-DD"));
      const sevenDaysBeforeDate = new Date();
      sevenDaysBeforeDate.setDate(1);
      setDateValue1(moment(sevenDaysBeforeDate).format("YYYY-MM-DD"));
    }
    if (activeTab === "dum") {
      getRejectionReasonscsa();
      setSelectDate(false);
      const todayDate = new Date();
      setDateValue1(moment(todayDate).format("YYYY-MM-DD"));
      const sevenDaysBeforeDate = new Date();
      sevenDaysBeforeDate.setDate(1);
      setDateValue2(moment(sevenDaysBeforeDate).format("YYYY-MM-DD"));
    }
  }, [activeTab]);

  const handleButtonClick = (mode) => {
    setSelectedMode(mode);
  };
  const handleButtonClickNes = (mode) => {
    setSelectedModeNes(mode);
  };

  useEffect(() => {
    if (selectedModeNes === "rejectreason") {
      getfunnelreport("rejectreason");
    }
    if (selectedModeNes === "all") {
      getAllfunnelreport();
    }
    if (selectedMode === "cpc") {
      getAllCPCfunnelreport();
    }
  }, [selectedMode, selectedModeNes]);
  const handleMonthChange = (e) => {
    const newMonth = e.target.value;
    setMonth(newMonth);
  };

  const getfunnelreport = (item) => {
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/getFunnelRepoRejection/${month}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        if (response?.data !== "") {
          setData(response?.data);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const getAllfunnelreport = (item) => {
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/getFunnelRepoSTD/${month}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        if (response?.data !== "") {
          setDataAllFunnelData(response?.data);
        } else {
          setDataAllFunnelData([]);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const getAllCPCfunnelreport = (item) => {
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/getFunnelRepoCPC/${month}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        if (response?.data !== "") {
          setDataAllCPCFunnelData(response?.data);
        } else {
          setDataAllCPCFunnelData([]);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const getClist = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/cList`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setClist(response?.data);
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const getfunnelreportcount = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/getfunnelreportcount`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        SetFunnel(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const handleSubmit = () => {
    getRejectionReasonscsa();
  };

  const getRejectionReasonscsa = () => {
    setIsLoader(true);
    axios
      .request(
        `${APIURL}/rejectionReasonscsa/${dateValue2}/${dateValue1}/${option}`,
        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsLoader(false);
        setRow(response?.data);
        console.log("response?.data::: ", response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  return (
    <div className="container-fluid p-3">
      <div className="row">
        <div className="col-12">
          <ul
            className="nav nav-tabs flex-column flex-sm-row"
            id="myTab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "home" ? "active" : ""}`}
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#home"
                type="button"
                role="tab"
                aria-controls="home"
                aria-selected={activeTab === "home"}
                onClick={() => handleTabClick("home")}
              >
                Funnel
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "dum" ? "active" : ""}`}
                id="dum-tab"
                data-bs-toggle="tab"
                data-bs-target="#dum"
                type="button"
                role="tab"
                aria-controls="dum"
                aria-selected={activeTab === "dum"}
                onClick={() => handleTabClick("dum")}
              >
                Login Dump
              </button>
            </li>
          </ul>

          <div className="tab-content mt-3" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div className="card">
                <div className="card-body">
                  <div className="mb-3">
                    <ul className="nav nav-tabs flex-column flex-sm-row">
                      <li className="nav-item mb-2 mb-sm-0 me-sm-2">
                        <button
                          className={`nav-link btn ${
                            selectedMode === "openmarket"
                              ? "btn-primary active"
                              : "btn-outline-primary"
                          }`}
                          role="tab"
                          onClick={() => handleButtonClick("openmarket")}
                        >
                          Open Market
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link btn ${
                            selectedMode === "cpc"
                              ? "btn-primary active"
                              : "btn-outline-primary"
                          }`}
                          role="tab"
                          onClick={() => handleButtonClick("cpc")}
                        >
                          CPC
                        </button>
                      </li>
                    </ul>
                    <hr />
                  </div>

                  {selectedMode === "openmarket" && (
                    <div>
                      <div className="mb-3">
                        <ul className="nav nav-tabs flex-column flex-sm-row">
                          <li className="nav-item mb-2 mb-sm-0 me-sm-2">
                            <button
                              className={`nav-link btn ${
                                selectedModeNes === "all"
                                  ? "btn-dark active"
                                  : "btn-outline-dark"
                              }`}
                              role="tab"
                              onClick={() => handleButtonClickNes("all")}
                            >
                              All
                            </button>
                          </li>
                          <li className="nav-item">
                            <button
                              className={`nav-link btn ${
                                selectedModeNes === "rejectreason"
                                  ? "btn-dark active"
                                  : "btn-outline-dark"
                              }`}
                              role="tab"
                              onClick={() =>
                                handleButtonClickNes("rejectreason")
                              }
                            >
                              Reject Reason
                            </button>
                          </li>
                        </ul>
                      </div>

                      <div className="row mb-3">
                        <div
                          className="col-12 col-md-6 mb-2 mb-md-0"
                          style={{ width: "150px" }}
                        >
                          <DownloadTableExcel
                            filename="Funnel"
                            sheet="users"
                            currentTableRef={tableFunnel.current}
                          >
                            <button className="btn btn-success w-100">
                              Download
                            </button>
                          </DownloadTableExcel>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="d-flex">
                            <select
                              className="form-select flex-grow-1 me-2"
                              id="lang"
                              onChange={handleMonthChange}
                              value={month}
                            >
                              {months.map(({ name, value }) => (
                                <option key={value} value={value}>
                                  {name}
                                </option>
                              ))}
                            </select>
                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                selectedModeNes === "all"
                                  ? getAllfunnelreport(month)
                                  : getfunnelreport(selectedMode, month)
                              }
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <div
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              ) : (
                                "Search"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="table-responsive">
                        <table
                          className="table table-striped table-hover"
                          ref={tableFunnel}
                        >
                          <thead className="table">
                            <tr>
                              <th>Sr. No</th>
                              <th>Entry dt</th>
                              <th>App id</th>
                              <th>Branch Name</th>
                              <th>Customer Name</th>
                              <th>Mobile No.</th>
                              <th>Quick Profile</th>
                              <th>Aadhaar Update</th>
                              <th>KYC</th>
                              <th>Equifax</th>
                              <th>Enach</th>
                              <th>Account Aggregator</th>
                              <th>PD Verify</th>
                              <th>CA Pending</th>
                              <th>Email Verify</th>
                              <th>TnC</th>
                              <th>Disburse</th>
                              <th>Reject Reason</th>
                            </tr>
                          </thead>
                          <tbody>
                            {isLoader ? (
                              <tr>
                                <td colSpan="18" className="text-center">
                                  <div
                                    className="spinner-border text-primary"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      Loading...
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              (selectedModeNes === "all"
                                ? allFunnelData
                                : data
                              )?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>
                                    {item?.entryDate
                                      ? moment(item.entryDate).format(
                                          "DD-MM-YYYY"
                                        )
                                      : ""}
                                  </td>
                                  <td>{item?.appClientId}</td>
                                  <td>{item?.branchName || "-"}</td>
                                  <td>{item?.clientName}</td>
                                  <td>{item?.mobileNo}</td>
                                  <td
                                    className={getStatusClass(
                                      item?.quickProfiles
                                    )}
                                  >
                                    {item?.quickProfiles || "Pending"}
                                  </td>
                                  <td
                                    className={getStatusClass(
                                      item?.aadhaarNumberUpdate
                                    )}
                                  >
                                    {item?.aadhaarNumberUpdate || "Pending"}
                                  </td>
                                  <td className={getStatusClass(item?.kyc)}>
                                    {item?.kyc || "Pending"}
                                  </td>
                                  <td className={getStatusClass(item?.equfax)}>
                                    {item?.equfax || "Pending"}
                                  </td>
                                  <td className={getStatusClass(item?.enatch)}>
                                    {item?.enatch || "Pending"}
                                  </td>
                                  <td
                                    className={getStatusClass(
                                      item?.account_aggrgator
                                    )}
                                  >
                                    {item?.account_aggrgator || "Pending"}
                                  </td>
                                  <td
                                    className={getStatusClass(item?.pdVerify)}
                                  >
                                    {item?.pdVerify || "Pending"}
                                  </td>
                                  <td
                                    className={getStatusClass(
                                      item?.creditAppraisalPending
                                    )}
                                  >
                                    {item?.creditAppraisalPending || "Pending"}
                                  </td>
                                  <td
                                    className={getStatusClass(
                                      item?.emailVerity
                                    )}
                                  >
                                    {item?.emailVerity || "Pending"}
                                  </td>
                                  <td
                                    className={getStatusClass(
                                      item?.termAndCondition
                                    )}
                                  >
                                    {item?.termAndCondition || "Pending"}
                                  </td>
                                  <td
                                    className={getStatusClass(item?.disburse)}
                                  >
                                    {item?.disburse || "Pending"}
                                  </td>
                                  <td>{item?.rejectReason || "-"}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {selectedMode === "cpc" && (
                    <div>
                      <div className="row mb-3">
                        <div
                          className="col-12 col-md-6 mb-2 mb-md-0"
                          style={{ width: "150px" }}
                        >
                          <DownloadTableExcel
                            filename="Funnel"
                            sheet="users"
                            currentTableRef={tableFunnel.current}
                          >
                            <button className="btn btn-success w-100">
                              Download
                            </button>
                          </DownloadTableExcel>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="d-flex">
                            <select
                              className="form-select flex-grow-1 me-2"
                              id="lang"
                              onChange={handleMonthChange}
                              value={month}
                            >
                              {months.map(({ name, value }) => (
                                <option key={value} value={value}>
                                  {name}
                                </option>
                              ))}
                            </select>
                            <button
                              className="btn btn-primary"
                              onClick={() => getAllCPCfunnelreport(month)}
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <div
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              ) : (
                                "Search"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <thead className="table">
                            <tr>
                              <th>Sr. No</th>
                              <th>Entry dt</th>
                              <th>Entry time</th>
                              <th>App id</th>
                              <th>Branch Name</th>
                              <th>Customer Name</th>
                              <th>Mobile No.</th>
                              <th>TnC</th>
                              <th>Disburse</th>
                              <th>Reject Reason</th>
                            </tr>
                          </thead>
                          <tbody>
                            {isLoader ? (
                              <tr>
                                <td colSpan="10" className="text-center">
                                  <div
                                    className="spinner-border text-primary"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      Loading...
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              allCPCFunnelData?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>
                                    {item?.entryDate
                                      ? moment(item.entryDate).format(
                                          "DD-MM-YYYY"
                                        )
                                      : ""}
                                  </td>
                                  <td>
                                    {item?.entryDate
                                      ? moment(item.entryDate).format(
                                          "HH:mm:ss"
                                        )
                                      : ""}
                                  </td>
                                  <td>{item?.appClientId}</td>
                                  <td>{item?.branchName}</td>
                                  <td>{item?.clientName}</td>
                                  <td>{item?.mobileNo}</td>
                                  <td
                                    className={getStatusClass(
                                      item?.termAndCondition
                                    )}
                                  >
                                    {item?.termAndCondition || "-"}
                                  </td>
                                  <td
                                    className={getStatusClass(item?.disburse)}
                                  >
                                    {item?.disburse || "-"}
                                  </td>
                                  <td>{item?.rejectReason || "-"}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="dum"
              role="tabpanel"
              aria-labelledby="dum-tab"
            >
              <div className="card">
                <div className="card-body">
                  <div className="mb-3">
                    <div className="row g-3 align-items-center">
                      <div className="col-12 col-md-auto">
                        <DownloadTableExcel
                          filename="Login Dump"
                          sheet="users"
                          currentTableRef={tableRef.current}
                        >
                          <button className="btn btn-dark w-100">
                            Download
                          </button>
                        </DownloadTableExcel>
                      </div>

                      <div className="col-12 col-md">
                        <div className="row g-2">
                          <div className="col-12 col-sm-auto">
                            <select
                              className="form-select"
                              onChange={(e) => setOption(e.target.value)}
                              value={option}
                            >
                              {list.map((item) => (
                                <option key={item.value} value={item.value}>
                                  {item}
                                </option>
                              ))}
                            </select>
                          </div>

                          {!selectDate ? (
                            <div className="col-12 col-sm-auto">
                              <button
                                className="btn btn-dark w-100"
                                onClick={() => setSelectDate(true)}
                              >
                                Select Date
                              </button>
                            </div>
                          ) : (
                            <>
                              <div className="col-12 col-md">
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DatePicker
                                    label="From Date"
                                    value={
                                      dateValue2 ? new Date(dateValue2) : null
                                    }
                                    format="dd-MM-yyyy"
                                    onChange={(e) =>
                                      setDateValue2(
                                        moment(e).format("YYYY-MM-DD")
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              </div>

                              <div className="col-12 col-md">
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DatePicker
                                    label="To Date"
                                    value={
                                      dateValue1 ? new Date(dateValue1) : null
                                    }
                                    format="dd-MM-yyyy"
                                    onChange={(e) =>
                                      setDateValue1(
                                        moment(e).format("YYYY-MM-DD")
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              </div>

                              <div className="col-12 col-md-auto">
                                <button
                                  className="btn btn-dark w-100"
                                  onClick={() => handleSubmit()}
                                >
                                  Submit
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {showSearch ? (
                    <>
                      <div className="mb-3">
                        <button
                          className="btn btn-secondary"
                          onClick={() => setShowSearch(false)}
                        >
                          Back
                        </button>
                      </div>
                      <LoanDetails lid={lid} />
                    </>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-striped table-hover">
                        <thead className="table">
                          <tr>
                            <th>S No.</th>
                            <th>EntryDate</th>
                            <th>Loan Id</th>
                            <th>ContactNo</th>
                            <th>Name</th>
                            <th>AadhaarId</th>
                            <th>PanCard</th>
                            <th>Email id</th>
                            <th>App client id</th>
                            <th>Application Status</th>
                            <th>Rejected Reason</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoader ? (
                            <tr>
                              <td colSpan="11" className="text-center">
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            row.length &&
                            row &&
                            row
                              ?.slice(pagination.start, pagination.end)
                              ?.map((row, index) => (
                                <tr key={index}>
                                  <td>{index + 1 + pagination.start}</td>
                                  <td>
                                    {moment(row?.entrydate).format(
                                      "DD-MM-YYYY"
                                    ) || "-"}
                                  </td>
                                  <td
                                    className="text-primary cursor-pointer"
                                    onClick={() => {
                                      if (row.loanId) {
                                        setLid(row.loanId);
                                        setShowSearch(true);
                                      }
                                    }}
                                  >
                                    {row?.loanId || "-"}
                                  </td>
                                  <td>{row?.contactno || "-"}</td>
                                  <td>{row?.name || "-"}</td>
                                  <td>{row?.aadhaarid || "-"}</td>
                                  <td>{row?.pancard || "-"}</td>
                                  <td>{row?.emailid || "-"}</td>
                                  <td>{row?.appclientid || "-"}</td>
                                  <td>{row?.applicationstatus || "-"}</td>
                                  <td>{row?.rejectedreason || "-"}</td>
                                </tr>
                              ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {/* {row && row?.length !== 0 && (
                    <Pagination
                      showPerPage={showPrePage}
                      onPaginationChange={onPaginationChange}
                      total={row?.length}
                    />
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  function getStatusClass(status) {
    if (status === "Done") return "text-success";
    if (status === "Rejected") return "text-danger";
    return "";
  }
}

export default FunnelCT;
